import { Model } from "@bryntum/schedulerpro";

export class TaskIntegrationsModel extends Model {
  static get $name() {
    return "TaskIntegrationsModel";
  }

  declare key: string;
  declare value: string;
  declare taskId: number;

  static get fields() {
    return ["key", "value", { name: "taskId", dataSource: "task", type: "number" }];
  }
}

// @ts-expect-error exposeProperties is an internal method
TaskIntegrationsModel.exposeProperties();
